const boxes = document.querySelectorAll('[data-animate-box]');

const elementObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.querySelector('[data-animate-img]').classList.add('animate');
    } else {
      entry.target.querySelector('[data-animate-img]').classList.remove('animate');
    }
  });
}, {
  rootMargin: '0px',
  threshold: [0.4, 0.6],
});

// run
if (boxes) {
  [].slice.call(boxes).forEach((box) => {
    elementObserver.observe(box);
  });
}
